<template>
	<div style="height:100%;">
		<wc-header headerTitle="资产信息" :BackisShow=BackisShow></wc-header>
		
			<wc-asset class="conSty" :style="style" :hardwareData="HardwareData" :softwareData="SoftwareData"></wc-asset>
		
	</div>
</template>

<script>
	import {_api} from '@/service/interface'
	
	export default{
		name: 'Point',
		data(){
			return {
				style:{
					    position: "relative",
	    				bottom: 0,
	    				top: "44px"
				},
				color:["#FB7E0D","#FF6C68","#1089D8","#12CCBE","#9DB1F8","#F8B608","#FA8D8F","#C6CD27","#D0CBEB","#C47BB2","#ECD7C6","#D0A53D","#D31528","#889A20","#7A2938","#708A93","#F1A4B6","#E86352","#E1BDC1","#E98188","#BCE3EA","#BF251D","#EF9DA1","#ECF4C3","#FEF2CC","#BC93BF","#82C0E7","#E9B87D","#F1AD98","#8B91CD"],
				BackisShow:true,
				HardwareData:[],
				SoftwareData:[],
				/*hardwareDatas:{
					list:[
						{value:3,name:"S5130-28S-HPWR-EI"},
						{value:22,name:"LSU3WCMD0"},
						{value:2,name:"SR6602-X"},
						{value:7,name:"SecPath F1070"},
						{value:4,name:"S10506"},
						{value:2,name:"S5130-52S-PWR-EI"},
						{value:7,name:"SecPath L1000-A"}
					]
				},
				softwareDatas:{
					list:[
						{value:3,name:"CMW5.20.106-R3303P16"},
						{value:6,name:"CMW7.1.045-R3109P09"},
						{value:3,name:"CMW7.1.064-E9313P02"},
						{value:3,name:"CMWRelease-R2509P46"},
						{value:3,name:"CMW7.1.045-R7170"},
						{value:S3,name:"CMW5.20-E7904P03"}
						
					]
				}*/
			}
		},
		watch:{
			
		},
		methods:{
			/*createHardData(){
				var data =this.hardwareDatas.list;
				for(var i=0;i<data.length;i++){
					this.hardwareData.push({value:data[i].value,name:data[i].name,color:this.color[i]})
				}
			},
			createSoftData(){
				var data =this.softwareDatas.list;
				for(var i=0;i<data.length;i++){
					this.softwareData.push({value:data[i].value,name:data[i].name,color:this.color[i]})
				}
			},*/
			getData(index){
				let paramList=['Hardware','Software'];
				let resMap={0:{name:'devSeriesName',value:'devTotals'},1:{name:'softSystemType',value:'softTotals'}};
				_api('_asset','.code',{params:{mark:paramList[index]}},res=>{
					console.error(1111,res,222,this[paramList[index]+'Data'],333,this)
					this[paramList[index]+'Data']=[];
					res.data.list.forEach((item,num)=>{
						if(num<this.color.length){
							this[paramList[index]+'Data'].push({value:item[resMap[index].value],name:item[resMap[index].name],color:this.color[num]});
						}else{
							this[paramList[index]+'Data'].push({value:item[resMap[index].value],name:item[resMap[index].name],color:this.color[num%this.color.length-1]});
						}
					})
				},err=>{
					
				})
			}
		},
		mounted(){
			this.getData(0);
			this.getData(1);
		}
	}
</script>

<style>
	body{
		background: #F3F3F3;
	}
	.conSty{
		position: relative;
	    bottom: 0;
	    top: 45px;
	}
</style>


// WEBPACK FOOTER //
// src/views/asset/Asset.vue